// extracted by mini-css-extract-plugin
export var button = "_cn-4";
export var hasDarkBackground = "_cn-7";
export var hasLightBackground = "_cn-6";
export var iconWrapper = "_cn-0";
export var large = "_cn-2";
export var medium = "_cn-1";
export var small = "_cn-5";
export var xsmall = "_cn-3";